export default __webpack_public_path__ + "assets/images/f30c6b71b2454c47a22a2f42788b9ac9.svg";